<template>
  <div id="app">
    
    <router-view/>
    <!-- <div>
      <a href="gysd.html">跳转新的页面</a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
